// src/index.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { setupAxiosInterceptors } from './utils/axiosInterceptor';

// SET UP AXIOS INTERCEPTORS BEFORE RENDERING
// This ensures the JWT token is attached to all API requests
setupAxiosInterceptors();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
